import { render } from "./paypal-payment.vue?vue&type=template&id=44eca5b4"
import script from "./paypal-payment.vue?vue&type=script&lang=js"
export * from "./paypal-payment.vue?vue&type=script&lang=js"

import "./paypal-payment.vue?vue&type=style&index=0&id=44eca5b4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__